window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.streamDashboard = window.locales.am.streamDashboard || {};window.locales.am.streamDashboard.streamDashboard = window.locales.am.streamDashboard.streamDashboard || {};window.locales.am.streamDashboard.streamDashboard = {...window.locales.am.streamDashboard.streamDashboard, ...{
    "completion_course_complete": "ኮርስ ተጠናቅቋል",
    "completion_exam_complete": "ፈተና ተጠናቅቋል",
    "completion_continue": "ቀጥል",
    "completion_return_to_dashboard": "ወደ ዳሽቦርድ ይመለሱ",
    "completion_exam_is_complete": "የእርስዎ ፈተና ተጠናቅቋል። የእርስዎን ነጥቦች እናሰላለን ከዚያም ወደመጨረሻ ውጤትዎ እናስገባለን።",
    "completion_share_with_friend": "ከ {brandName} ኮርሶች ሊጠቀም ከሚችል ጓደኛዎ ጋር በነጻነት ያጋሩ።",
    "completion_great_job": "ምርጥ ስራ!",
    "share": "ያጋሩ",
    "tweet": "ትዊት",
    "email": "ኢሜይል",
    "add_to_my_courses": "ወደ ዕልባቶች ያክሉ",
    "additional_resources": "ተጨማሪ ግብአቶች",
    "after_launching_first_you_will_have": "የመጀመሪያዉ ትምህርት ከጀመሩ በኋላ፣ ፈተናውን ለማጠናቀቅ <timeLeft>{timeLeft}</timeLeft> አለዎት።",
    "after_launching_next_you_will_have": "ቀጣዩን ትምህርት ከጀመሩ በኋላ፣ ፈተናውን ለማጠናቀቅ <timeLeft>{timeLeft}</timeLeft> አለዎት።",
    "beta": "ቤታ",
    "chapter_number_x": "ምዕራፍ {number}",
    "coming_soon": "በቅርብ ቀን!",
    "coming_soon_block": "በቅርቡ<lineBreak/>ይመጣል",
    "coming_soon_come_back_later": "ያሉትን ሁለንም የቤታ ትምህርቶች አጠናቅቀዋል! የበለጠ በሚታተምበት ጊዜ በኋላ ላይ መልሰው ያረጋግጡ።",
    "coming_soon_inline": "በቅርቡ ይመጣል",
    "completed_score": "ተጠናቅቋል {score}%",
    "course_description": "የኮርሱ መግለጫ",
    "course_details": "<br>ኮርስ ዝርዝሮች",
    "course_highlights": "የኮርስ ዋና ነጥቦች",
    "course_summaries": "የኮርስ ማጠቃለያዎች",
    "credits": "ክሬዲቶች",
    "download_certificate": "ሰርተፍኬት ያውርዱ",
    "exam_begins": "ፈተናው ጀምሯል",
    "exam_score": "የፈተና ውጤት",
    "exam_timer": "የፈተና ጊዜ መቁጠሪያ",
    "explore_key_terms": "ቁልፍ ቃላትን ያስሱ",
    "external_links": "የተመደበ ንባብ",
    "external_links_intro": "የ {brandName} ትምህርቶች ብዙውን ጊዜ ተማሪዎች ስለ አንድ ርዕሰ ጉዳይ የበለጠ የሚማሩባቸው ከውጭ መጣጥፎች እና ሌሎች ድረ-ገጾች ጋር ይገናኛሉ። የእያንዳንዱ ኮርስ ማጠናቀቂያ አካል ተማሪዎች እነዚህን ጽሑፎች እንዲያነቡ ይጠበቅባቸዋል። ወደ URL ለማሰስ ከዚህ በታች ያለውን ማንኛውንም አገናኝ ይንኩ።",
    "join": "ይቀላቀሉ{brandName}",
    "join_for_upsell_desc": "የ{brandName} የኮርስ ቤተመጻህፍትን ለማግኘት መለያ ይጠይቃል።",
    "key_terms": "ቁልፍ ቃላት",
    "key_terms_description": "ቁልፍ ቃላት ይህን ትምህርት በሚወሰድበት ጊዜ ልዩ ትኩረት ይገባቸዋል ብሎ {brandName} የሚያንባቸው ሃሳቦች ናቸው። ከዚህ በታች ያለውን ዝርዝር ማንኛዉም ቃል ነካ በማድረግ ሲተዋወቅ ወደነበረው ትምህርት በቀጥታ ይሂዱ።",
    "launch_completed": "ተጠናቋል።",
    "launch_locked": "ተቆልፏል",
    "launch_resume": "ከቆመበት ቀጥል",
    "launch_review": "ይገምግሙ",
    "launch_start": "ጀምር",
    "learn_more": "ተጨማሪ ይማሩ",
    "lesson_locked_title": "ትምህርቱ ተቆልፏል",
    "lesson_number_x": "ትምህርት {number}",
    "login": "ይግቡ",
    "next_up": "ቀጥሎ ያለው፤",
    "num_lessons_completed": "ከ {total} ትምህርቶች {count} ተጠናቋል",
    "num_lessons_completed_short": "{count} ከ {total} ትምህርቶች",
    "optional": "አማራጭ",
    "ready_to_begin": "ለመጀመር ዝግጁ ነዎት?",
    "ready_to_begin_exam": "ለመጀመር ዝግጁ ነዎት? አሁን ፈተናዎን ይጀምሩ።",
    "ready_to_begin_start_learning": "ለመጀመር ዝግጁ ነዎት? <lineBreak/> አሁን መማር ይጀምሩ።",
    "ready_to_begin_verify_identity": "ለመጀመር ዝግጁ ነዎት? ፈተናውን ለመክፈት ማንነትዎን ያረጋግጡ።",
    "ready_to_continue_verify_identity": "ለመቀጠል ዝግጁ ነዎት? ፈተናውን ለመክፈት ማንነትዎን ያረጋግጡ።",
    "recommended_study": "የሚመከር ጥናት",
    "related_courses": "ግንኙነት ያላቸው ኮርሶች",
    "resources": "ግብአቶች",
    "saved_to_my_courses": "ወደ ዕልባቶች ተቀምጠዋል",
    "schedule": "መርሃግብር",
    "show_more": "ተጨማሪ አሳይ",
    "signing_certificate": "ሰርተፍኬት በመፈረም ላይ",
    "smartcase": "SMARTCASE",
    "start": "ጀምር",
    "start_course": "ኮርሱን ይጀምሩ",
    "start_exam": "ፈተና ይጀምሩ",
    "tap_to_download": "ለማውረድ ነካ ያድርጉ",
    "tap_to_remove": "ለማስወገድ ነካ ያድርጉ",
    "test": "ፈተና",
    "the_exam_time_will_begin": "ጊዜ ቆጣሪው የመጀመሪያዎን ትምህርት ሲከፍቱ ይጀምራል። ከ {timeLimitHours} ሰአት በኋላ፣ ፈተናዎ ጊዜዎ ይጠናቀቃል፣ እና ምንም ተጨማሪ መልሶች ተቀባይነት አይኖራቸውም።",
    "time_limit": "የጊዜ ገደብ",
    "title_not_available": "ርዕስ አይገኝም",
    "verified_identity_thanks": "ማንነትዎን ስላረጋገጡ እናመሰግናለን። ፈተናህን አሁን ጀምር።",
    "verify_identity": "ማንነትን አረጋግጥ",
    "view_schedule": "መርሃግብር ይመልከቱ",
    "we_suggest_following_x": "<strong>{title}</strong>ከመጀመርዎ በፊት በሚከተሉት ኮርሶች ውስጥ ካለው የትምህርት መሳሪያ ጋር እንዲተዋወቁ እንጠቁምዎታለን፤",
    "you_have_x_remaining": "እርስዎ <timeLeft>{timeLeft}</timeLeft> ይቀርዎታል",
    "you_will_have_x_hours": "ፈተናዎን ከጀመሩበት ጊዜ አንስቶ ለማጠናቀቅ {numHours} ሰአት አለዎት።",
    "course_information": "የኮርስ መረጃ",           
    "server_error": "የሰርቨር ስህተት",           
    "retry": "እንደገና ሞክር",           
    "beta_message": "የቤታ ኮርሶች አሁንም በሂደት ላይ ናቸው! ኮርሶቹ የትምህርቶቹን ቅድሚያ ስሪቶች ለመሞከር ለሚፈልጉ ጀብደኛ ተማሪዎች ይገኛሉ።"           
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.streamDashboard = window.locales.ar.streamDashboard || {};window.locales.ar.streamDashboard.streamDashboard = window.locales.ar.streamDashboard.streamDashboard || {};window.locales.ar.streamDashboard.streamDashboard = {...window.locales.ar.streamDashboard.streamDashboard, ...{
    "completion_course_complete": "انتهت الدورة",
    "completion_exam_complete": "امتحان اكتملت",
    "completion_continue": "استمر",
    "completion_return_to_dashboard": "عودة إلى لوحة التحكم",
    "completion_exam_is_complete": "الامتحان الخاص بك مكتمل. وسوف نقوم بحساب علاماتك وإضافتهم إلى العلامة النهائية الخاصة بك.",
    "completion_share_with_friend": "لا تتردد في المشاركة مع صديق قد يستفيد من {brandName} .",
    "completion_great_job": "عمل رائع!",
    "share": "شارِك",
    "tweet": "غرّد",
    "email": "البريد الإلكتروني",
    "add_to_my_courses": "أضف إلى الإشارات المرجعية",
    "additional_resources": "الموارد الإضافية",
    "after_launching_first_you_will_have": "بعد إطلاق الدرس الأول، سيكون لديك <timeLeft>{timeLeft}</timeLeft> لإكمال الامتحان.",
    "after_launching_next_you_will_have": "بعد إطلاق الدرس التالي، سيكون لديك <timeLeft>{timeLeft}</timeLeft> لإكمال الامتحان.",
    "beta": "BETA",
    "chapter_number_x": "الفصل {number}",
    "coming_soon": "قريباً!",
    "coming_soon_block": "قريباً",
    "coming_soon_come_back_later": "لقد أكملت جميع الدروس التجريبية المتاحة! تحقق من الأمر مرةً أخرى في وقتٍ لاحق عندما يتم نشر المزيد من الدروس.",
    "coming_soon_inline": "قريباً",
    "completed_score": "تم الانتهاء: {score}%",
    "course_description": "وصف الدورة",
    "course_details": "تفاصيل<br>الدورة",
    "course_highlights": "مميزات الدورة",
    "course_summaries": "ملخصات الدورة",
    "credits": "الحقوق",
    "download_certificate": "تحميل الشهادة",
    "exam_begins": "تباشر الامتحانات",
    "exam_score": "درجة الامتحان",
    "exam_timer": "امتحان TIMER",
    "explore_key_terms": "اكتشف المصطلحات الأساسية",
    "external_links": "القراءة المعينة",
    "external_links_intro": "غالبًا ما ترتبط دروس {brandName} بالمقالات الخارجية وصفحات الويب الأخرى حيث يمكن للطلاب معرفة المزيد حول موضوع معين. يتوقع من الطلاب قراءة هذه المقالات كجزء من إكمال كل دورة. اضغط على أي رابط أدناه للانتقال إلى عنوان URL.",
    "join": "انضم إلى {brandName}",
    "join_for_upsell_desc": "يتطلب الوصول إلى مكتبة الدورات التدريبية {brandName} حسابًا.",
    "key_terms": "المصطلحات الأساسية",
    "key_terms_description": "المصطلحات الأساسية هي المفاهيم التي يعتقد {brandName} أنها تستحق اهتمامًا خاصًا عند دراسة هذا الموضوع. انقر فوق أي مصطلح رئيسي في القائمة أدناه للتنقل مباشرةً إلى الدرس الذي تم تقديمه فيه.",
    "launch_completed": "مكتملة",
    "launch_locked": "مغلقة",
    "launch_resume": "استئناف",
    "launch_review": "مراجعة",
    "launch_start": "ابدأ",
    "learn_more": "تعلم المزيد",
    "lesson_locked_title": "الدرس مقفل",
    "lesson_number_x": "الدرس {number}",
    "login": "تسجيل الدخول",
    "next_up": "الخطوة التالية:",
    "num_lessons_completed": "{count} من {total} درسًا مكتملًا",
    "num_lessons_completed_short": "{count} من {total} درسًا",
    "optional": "خياري",
    "ready_to_begin": "استعداد لبدء؟",
    "ready_to_begin_exam": "استعداد لبدء؟ بدء الامتحان الخاص بك الآن.",
    "ready_to_begin_start_learning": "هل أنت مستعد للبدء؟ <lineBreak/> ابدأ في التعلم الآن.",
    "ready_to_begin_verify_identity": "جاهز للبدء؟ تحقق من هويتك لفتح الامتحان.",
    "ready_to_continue_verify_identity": "جاهز للمتابعة؟ تحقق من هويتك لفتح الامتحان.",
    "recommended_study": "الدراسة الموصى بها",
    "related_courses": "الدورات ذات الصلة",
    "resources": "الموارد",
    "saved_to_my_courses": "تم الحفظ إلى الإشارات المرجعية",
    "schedule": "جدول",
    "show_more": "عرض المزيد",
    "signing_certificate": "جاري توقيع الشهادة",
    "smartcase": "SMARTCASE",
    "start": "بداية",
    "start_course": "ابدأ الدورة",
    "start_exam": "بدء الامتحان",
    "tap_to_download": "انقر تحميل",
    "tap_to_remove": "انقر للإزالة",
    "test": "اختبار",
    "the_exam_time_will_begin": "ستبدأ توقيت الامتحان عند بدء الدرس الأول الخاص بك. بعد {timeLimitHours} ساعة، والامتحان الخاص بك يغلق، وسيتم قبول أية إجابات إضافية.",
    "time_limit": "الحد الزمني",
    "title_not_available": "العنوان غير متوفر",
    "verified_identity_thanks": "شكرا للتحقق من هويتك. ابدأ الامتحان الآن.",
    "verify_identity": "التحقق من الهوية",
    "view_schedule": "عرض الجدول الزمني",
    "we_suggest_following_x": "إننا نقترح عليك أن تقوم بالإطلاع على المواد العلمية في الدورات التالية قبل البدء <strong>{title}</strong>:",
    "you_have_x_remaining": "عندك <timeLeft>{timeLeft}</timeLeft> REMAINING",
    "you_will_have_x_hours": "سيكون لديك {numHours} ساعة من وقت بدء الامتحان لإنجاز ذلك.",
    "course_information": "معلومات الدورة",           
    "server_error": "خطأ في الخادم",           
    "retry": "إعادة المحاولة",           
    "beta_message": "الدورات التجريبية لا تزال قيد الاستخدام! إنها متاحة للمتعلمين المغامرين الذين يرغبون في تجربة الإصدارات القديمة من الدروس."           
}
};window.locales.en = window.locales.en || {};window.locales.en.streamDashboard = window.locales.en.streamDashboard || {};window.locales.en.streamDashboard.streamDashboard = window.locales.en.streamDashboard.streamDashboard || {};window.locales.en.streamDashboard.streamDashboard = {...window.locales.en.streamDashboard.streamDashboard, ...{
    "completion_course_complete": "COURSE COMPLETE",
    "completion_exam_complete": "EXAM COMPLETE",
    "completion_continue": "CONTINUE",
    "completion_return_to_dashboard": "RETURN TO DASHBOARD",
    "completion_exam_is_complete": "Your exam is complete. We will calculate your scores and factor them into your final grade.",
    "completion_share_with_friend": "Feel free to share with a friend who might benefit from {brandName}'s courses.",
    "completion_great_job": "GREAT JOB!",
    "share": "Share",
    "tweet": "Tweet",
    "email": "Email",
    "add_to_my_courses": "ADD TO BOOKMARKS",
    "additional_resources": "Additional Resources",
    "after_launching_first_you_will_have": "After launching the first lesson, you will have <timeLeft>{timeLeft}</timeLeft> to complete the exam.",
    "after_launching_next_you_will_have": "After launching the next lesson, you will have <timeLeft>{timeLeft}</timeLeft> to complete the exam.",
    "beta": "BETA",
    "chapter_number_x": "CHAPTER {number}",
    "coming_soon": "Coming Soon!",
    "coming_soon_block": "COMING<lineBreak/>SOON",
    "coming_soon_come_back_later": "You've completed all available Beta lessons! Check back later when more are published.",
    "coming_soon_inline": "COMING SOON",
    "completed_score": "Completed: {score}%",
    "course_description": "Course Description",
    "course_details": "COURSE<br>DETAILS",
    "course_highlights": "Course Highlights",
    "course_summaries": "Course Summaries",
    "credits": "Credits",
    "download_certificate": "Download Certificate",
    "exam_begins": "EXAM BEGINS",
    "exam_score": "Exam Score",
    "exam_timer": "Exam Timer",
    "explore_key_terms": "Explore Key Terms",
    "external_links": "Assigned Reading",
    "external_links_intro": "{brandName} lessons often link to external articles and other webpages where students can learn more about a particular subject. Students are expected to read these articles as part of the completion of each course. Tap on any link below to navigate to the URL.",
    "join": "Join {brandName}",
    "join_for_upsell_desc": "Access to {brandName}'s course library requires an account.",
    "key_terms": "Key Terms",
    "key_terms_description": "Key terms are concepts that {brandName} believes deserve special attention when studying this subject. Tap any key term in the list below to navigate directly to the lesson in which it was introduced.",
    "launch_completed": "COMPLETED",
    "launch_locked": "LOCKED",
    "launch_resume": "RESUME",
    "launch_review": "REVIEW",
    "launch_start": "START",
    "learn_more": "LEARN MORE",
    "lesson_locked_title": "Lesson Locked",
    "lesson_number_x": "LESSON {number}",
    "login": "LOGIN",
    "next_up": "NEXT UP:",
    "num_lessons_completed": "{count} of {total} lessons completed",
    "num_lessons_completed_short": "{count} of {total} lessons",
    "optional": "Optional",
    "ready_to_begin": "Ready to begin?",
    "ready_to_begin_exam": "Ready to begin? Start your exam now.",
    "ready_to_begin_start_learning": "Ready to begin? <lineBreak/> Start learning now.",
    "ready_to_begin_verify_identity": "Ready to begin? Verify your identity to unlock the exam.",
    "ready_to_continue_verify_identity": "Ready to continue? Verify your identity to unlock the exam.",
    "recommended_study": "Recommended Study",
    "related_courses": "Related Courses",
    "resources": "Resources",
    "saved_to_my_courses": "SAVED TO BOOKMARKS",
    "schedule": "Schedule",
    "show_more": "Show More",
    "signing_certificate": "Signing Certificate",
    "smartcase": "SMARTCASE",
    "start": "START",
    "start_course": "START COURSE",
    "start_exam": "Start Exam",
    "tap_to_download": "Tap to download",
    "tap_to_remove": "Tap to Remove",
    "test": "TEST",
    "the_exam_time_will_begin": "The exam timer will begin when you launch your first lesson. After {timeLimitHours} hours, your exam will close, and no additional answers will be accepted.",
    "time_limit": "TIME LIMIT",
    "title_not_available": "Title Not Available",
    "verified_identity_thanks": "Thanks for verifying your identity. Start your exam now.",
    "verify_identity": "VERIFY IDENTITY",
    "view_schedule": "VIEW SCHEDULE",
    "we_suggest_following_x": "We suggest you have familiarity with the material in the following courses before beginning <strong>{title}</strong>:",
    "you_have_x_remaining": "YOU HAVE <timeLeft>{timeLeft}</timeLeft> REMAINING",
    "you_will_have_x_hours": "You’ll have {numHours} hours from the time you start the exam to complete it.",
    "course_information": "Course Information",
    "server_error": "Server Error",
    "retry": "Retry",
    "beta_message": "Beta courses are still in progress! They're available to adventurous learners who want to try early versions of lessons."
}
};window.locales.es = window.locales.es || {};window.locales.es.streamDashboard = window.locales.es.streamDashboard || {};window.locales.es.streamDashboard.streamDashboard = window.locales.es.streamDashboard.streamDashboard || {};window.locales.es.streamDashboard.streamDashboard = {...window.locales.es.streamDashboard.streamDashboard, ...{
    "completion_course_complete": "CURSO COMPLETO",
    "completion_exam_complete": "EXAMEN COMPLETO",
    "completion_continue": "CONTINUAR",
    "completion_return_to_dashboard": "Volver al panel",
    "completion_exam_is_complete": "Su examen se haya completado. Vamos a calcular su puntuación y les cuenta en su calificación final.",
    "completion_share_with_friend": "No dudes en compartir con un amigo que podría beneficiarse de los cursos {brandName}",
    "completion_great_job": "¡GRAN TRABAJO!",
    "share": "Compartir",
    "tweet": "Tweet",
    "email": "Correo electrónico",
    "add_to_my_courses": "AÑADIR A MARCADORES",
    "additional_resources": "Recursos adicionales",
    "after_launching_first_you_will_have": "Tras el lanzamiento de la primera lección, tendrá <timeLeft>{timeLeft}</timeLeft> para completar el examen.",
    "after_launching_next_you_will_have": "Tras el lanzamiento de la próxima lección, tendrá <timeLeft>{timeLeft}</timeLeft> para completar el examen.",
    "beta": "BETA",
    "chapter_number_x": "CAPÍTULO {number}",
    "coming_soon": "¡Próximamente!",
    "coming_soon_block": "¡PRÓXIMAMENTE!",
    "coming_soon_come_back_later": "¡Has completado todas las lecciones Beta disponibles! Vuelve más tarde, cuando haya más publicadas.",
    "coming_soon_inline": "¡PRÓXIMAMENTE!",
    "completed_score": "Completado: {score}%",
    "course_description": "Descripción del curso",
    "course_details": "DETALLES DEL <br>CURSO",
    "course_highlights": "Lo Más Destacado del Curso",
    "course_summaries": "Resúmenes del curso",
    "credits": "Créditos",
    "download_certificate": "Descargar Certificado",
    "exam_begins": "EXAMEN COMIENZA",
    "exam_score": "Puntuación del examen",
    "exam_timer": "cronómetro del examen",
    "explore_key_terms": "Explorar Términos Claves",
    "external_links": "Lectura Asignada",
    "external_links_intro": "Las lecciones de {brandName} a menudo se vinculan a artículos externos y otras páginas web donde los estudiantes pueden obtener más información sobre un tema en particular. Se espera que los estudiantes lean estos artículos como parte de la finalización de cada curso. Toque cualquier enlace a continuación para navegar a la URL.",
    "join": "Únase a {brandName}",
    "join_for_upsell_desc": "El acceso a la biblioteca de cursos de {brandName} requiere una cuenta.",
    "key_terms": "Términos Clave",
    "key_terms_description": "Los términos clave son conceptos que {brandName} cree que merecen especial atención al estudiar este tema. Toque cualquier término clave en la lista a continuación para navegar directamente a la lección en la que se introdujo.",
    "launch_completed": "TERMINADO",
    "launch_locked": "BLOQUEADO",
    "launch_resume": "REANUDAR",
    "launch_review": "REVISAR",
    "launch_start": "EMPEZAR",
    "learn_more": "SABER MÁS",
    "lesson_locked_title": "Lección bloqueada",
    "lesson_number_x": "LECCIÓN {number}",
    "login": "INICIAR SESIÓN",
    "next_up": "A CONTINUACIÓN:",
    "num_lessons_completed": "{count} de {total} lecciones completadas",
    "num_lessons_completed_short": "{count} de {total} lecciones",
    "optional": "Opcional",
    "ready_to_begin": "Listo para comenzar?",
    "ready_to_begin_exam": "Listo para comenzar? Podrá comenzar el examen ahora.",
    "ready_to_begin_start_learning": "¿Listo para comenzar? <lineBreak/> Empieza a aprender ahora.",
    "ready_to_begin_verify_identity": "¿Listo para comenzar? Verifique su identidad para desbloquear el examen.",
    "ready_to_continue_verify_identity": "¿Listo para continuar? Verifique su identidad para desbloquear el examen.",
    "recommended_study": "Estudio Recomendado",
    "related_courses": "Cursos Relacionados",
    "resources": "Recursos",
    "saved_to_my_courses": "GUARDADO EN MARCADORES",
    "schedule": "Programar",
    "show_more": "Mostrar más",
    "signing_certificate": "Certificado de firma",
    "smartcase": "SMARTCASE",
    "start": "COMIENZO",
    "start_course": "INICIAR CURSO",
    "start_exam": "Comience examen",
    "tap_to_download": "Pulsa para descargar",
    "tap_to_remove": "Pulsa para eliminar",
    "test": "PRUEBA",
    "the_exam_time_will_begin": "El temporizador de examen comenzará cuando inicia su primera lección. Después {timeLimitHours} horas, su examen se cerrará y no se aceptarán respuestas adicionales.",
    "time_limit": "LÍMITE DE TIEMPO",
    "title_not_available": "Título no disponible",
    "verified_identity_thanks": "Gracias por verificar su identidad. Comience su examen ahora.",
    "verify_identity": "VERIFICAR IDENTIDAD",
    "view_schedule": "VER PROGRAMA",
    "we_suggest_following_x": "Te sugerimos que estés familiarizado con el material de los cursos siguientes antes de empezar <strong>{title}</strong>:",
    "you_have_x_remaining": "TIENES <timeLeft>{timeLeft}</timeLeft> RESTANTE",
    "you_will_have_x_hours": "Dispondrá de {numHours} horas desde el momento de iniciar el examen para completarlo.",
    "course_information": "Información del Curso",           
    "server_error": "Error del servidor",           
    "retry": "Reintentar",           
    "beta_message": "¡Los cursos beta todavía están! Están a disposición de los estudiantes aventureros que quieran probar las primeras versiones de las clases."           
}
};window.locales.it = window.locales.it || {};window.locales.it.streamDashboard = window.locales.it.streamDashboard || {};window.locales.it.streamDashboard.streamDashboard = window.locales.it.streamDashboard.streamDashboard || {};window.locales.it.streamDashboard.streamDashboard = {...window.locales.it.streamDashboard.streamDashboard, ...{
    "completion_course_complete": "CORSO COMPLETATO",
    "completion_exam_complete": "ESAME COMPLETATO",
    "completion_continue": "CONTINUA",
    "completion_return_to_dashboard": "TORNA ALLA BACHECA",
    "completion_exam_is_complete": "Il tuo esame è stato completato. Calcoleremo i tuoi punteggi e li includeremo nella tua valutazione finale.",
    "completion_share_with_friend": "Sentiti libero di condividere con un amico che potrebbe trarre vantaggio dai corsi di {brandName}",
    "completion_great_job": "OTTIMO LAVORO!",
    "share": "Condividi",
    "tweet": "Twitta",
    "email": "Email",
    "add_to_my_courses": "AGGIUNGI AI SEGNALIBRI",
    "additional_resources": "Risorse ulteriori",
    "after_launching_first_you_will_have": "Una volta avviata la prima lezione, avrai <timeLeft>{timeLeft}</timeLeft> per completare l'esame.",
    "after_launching_next_you_will_have": "Una volta avviata la prossima lezione, avrai <timeLeft>{timeLeft}</timeLeft> per completare l'esame.",
    "beta": "BETA",
    "chapter_number_x": "CAPITOLO {number}",
    "coming_soon": "In arrivo!",
    "coming_soon_block": "IN<lineBreak/>ARRIVO",
    "coming_soon_come_back_later": "Hai completato tutte le lezioni Beta disponibili! Torna quando ne saranno pubblicate di nuove.",
    "coming_soon_inline": "IN ARRIVO",
    "completed_score": "Completato: {score}%",
    "course_description": "Descrizione del corso",
    "course_details": "DETTAGLI<br>CORSO",
    "course_highlights": "Elementi Chiave del Corso",
    "course_summaries": "Riepiloghi Corso",
    "credits": "Riconoscimenti",
    "download_certificate": "Scarica Diploma",
    "exam_begins": "INIZIO ESAME",
    "exam_score": "Punteggio dell'esame",
    "exam_timer": "Timer Esame",
    "explore_key_terms": "Esplora Parole Chiave",
    "external_links": "Lettura Assegnata",
    "external_links_intro": "Le lezioni {brandName} spesso si collegano ad articoli esterni e ad altre pagine web in cui gli studenti possono saperne di più su un particolare argomento. Gli studenti sono tenuti a leggere questi articoli come parte del completamento di ogni corso. Toccare uno dei collegamenti sottostanti per accedere all'URL.",
    "join": "Iscriviti a {brandName}",
    "join_for_upsell_desc": "L'accesso alla libreria dei corsi di {brandName} richiede un account.",
    "key_terms": "Parole Chiave",
    "key_terms_description": "I termini chiave sono concetti che {brandName} ritiene meritino un'attenzione particolare quando si studia questa materia. Tocca un termine chiave nell'elenco seguente per navigare direttamente alla lezione in cui è stato introdotto.",
    "launch_completed": "COMPLETATO",
    "launch_locked": "BLOCCATO",
    "launch_resume": "RIPRENDI",
    "launch_review": "REVISIONE",
    "launch_start": "INIZIA",
    "learn_more": "MAGGIORI INFORMAZIONI",
    "lesson_locked_title": "Lezione Bloccata",
    "lesson_number_x": "LEZIONE {number}",
    "login": "ACCESSO",
    "next_up": "PROSSIMO:",
    "num_lessons_completed": "{count} di {total} lezioni completate",
    "num_lessons_completed_short": "{count} di {total} lezioni",
    "optional": "Opzionale",
    "ready_to_begin": "Pronto a cominciare?",
    "ready_to_begin_exam": "Pronto a cominciare? Inizia subito il tuo esame.",
    "ready_to_begin_start_learning": "Pronto a partire? <lineBreak/> Comincia subito a imparare.",
    "ready_to_begin_verify_identity": "Pronto per iniziare? Verifica la tua identità per sbloccare l'esame.",
    "ready_to_continue_verify_identity": "Pronto a continuare? Verifica la tua identità per sbloccare l'esame.",
    "recommended_study": "Studi Suggeriti",
    "related_courses": "Corsi Correlati",
    "resources": "Risorse",
    "saved_to_my_courses": "SALVATO NEI SEGNALIBRI",
    "schedule": "Calendario",
    "show_more": "Mostra altro",
    "signing_certificate": "Firma Certificato",
    "smartcase": "SMARTCASE",
    "start": "INIZIA",
    "start_course": "INIZIA CORSO",
    "start_exam": "Inizia Esame",
    "tap_to_download": "Tocca per scaricare",
    "tap_to_remove": "Tocca per rimuovere",
    "test": "TEST",
    "the_exam_time_will_begin": "Il timer dell'esame partirà appena avviata la tua prima lezione. Dopo {timeLimitHours} ore il tuo esame si chiuderà, e non sarà accettata alcuna risposta ulteriore.",
    "time_limit": "TEMPO LIMITE",
    "title_not_available": "Titolo non disponibile",
    "verified_identity_thanks": "Grazie per aver verificato la tua identità. Inizia ora il tuo esame.",
    "verify_identity": "VERIFICARE L'IDENTITA'",
    "view_schedule": "VISUALIZZA CALENDARIO",
    "we_suggest_following_x": "Prima di cominciare, ti consigliamo di maturare una certa familiarità con il materiale dei seguenti corsi<strong>{title}</strong>:",
    "you_have_x_remaining": "HAI <timeLeft>{timeLeft}</timeLeft> RESIDUI",
    "you_will_have_x_hours": "Avrai {numHours} ore dall'orario di inizio dell'esame per completarlo.",
    "course_information": "Informazioni Corso",           
    "server_error": "Errore server",           
    "retry": "Riprova",           
    "beta_message": "I corsi beta sono ancora attivi! Sono disponibili per quegli studenti avventurosi che vogliono provare le prime versioni delle lezioni."           
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.streamDashboard = window.locales.zh.streamDashboard || {};window.locales.zh.streamDashboard.streamDashboard = window.locales.zh.streamDashboard.streamDashboard || {};window.locales.zh.streamDashboard.streamDashboard = {...window.locales.zh.streamDashboard.streamDashboard, ...{
    "completion_course_complete": "课程完成",
    "completion_exam_complete": "测验完成",
    "completion_continue": "继续",
    "completion_return_to_dashboard": "返回仪表板",
    "completion_exam_is_complete": "你的测验已完成。我们将计算你的分数，并把其计入你的期末成绩。",
    "completion_share_with_friend": "请随意与可能从 {brandName}课程中受益的朋友分享。",
    "completion_great_job": "真不错！",
    "share": "分享",
    "tweet": "Twitter 发帖",
    "email": "电子邮件",
    "add_to_my_courses": "添加到书签",
    "additional_resources": "附加资源",
    "after_launching_first_you_will_have": "自第一节课启动后，你可在 <timeLeft>{timeLeft}</timeLeft>内完成测验。",
    "after_launching_next_you_will_have": "自下一节课启动后，你可在 <timeLeft>{timeLeft}</timeLeft>内完成测验。",
    "beta": "测试版",
    "chapter_number_x": "第 {number} 章",
    "coming_soon": "即将推出！",
    "coming_soon_block": "即将<lineBreak/>推出",
    "coming_soon_come_back_later": "您已完成所有可用的测试版课业！ 请在以后发布更多课业时再回来查看。",
    "coming_soon_inline": "即将推出",
    "completed_score": "已完成： {score}%",
    "course_description": "课程描述",
    "course_details": "课程<br>详细信息",
    "course_highlights": "课程要点",
    "course_summaries": "课程摘要",
    "credits": "开发者名单",
    "download_certificate": "下载证书",
    "exam_begins": "测验开始",
    "exam_score": "测验分数",
    "exam_timer": "测验计时",
    "explore_key_terms": "浏览关键术语",
    "external_links": "指定阅读材料",
    "external_links_intro": "{brandName}课程通常链接到外部文章和其他网页，学生可以在其中了解有关特定主题的更多信息。作为完成每门课程的一部分，学生应阅读这些文章。点击下面的任何链接以导航到该 URL。",
    "join": "加入{brandName}",
    "join_for_upsell_desc": "登录账号方可进入{brandName}的课程库。",
    "key_terms": "关键术语",
    "key_terms_description": "关键术语是{brandName}认为在研究这门学科时值得特别注意的概念。点击下面列表中的任何关键术语，就可以直接导航至相关介绍课程。",
    "launch_completed": "已完成",
    "launch_locked": "已锁定",
    "launch_resume": "继续",
    "launch_review": "审查",
    "launch_start": "开始",
    "learn_more": "了解更多",
    "lesson_locked_title": "课程已锁定",
    "lesson_number_x": "第 {number} 课",
    "login": "登录",
    "next_up": "接下来：",
    "num_lessons_completed": "已完成{count}节课，共{total}节课",
    "num_lessons_completed_short": "{count}节课，共{total}节课",
    "optional": "选修的",
    "ready_to_begin": "准备开始？",
    "ready_to_begin_exam": "准备开始？开始你的测验。",
    "ready_to_begin_start_learning": "准备好开始了吗？<lineBreak/>立即开始学习。",
    "ready_to_begin_verify_identity": "准备好开始了吗？验证您的身份以解锁考试。",
    "ready_to_continue_verify_identity": "准备好继续了吗？验证您的身份以解锁考试。",
    "recommended_study": "推荐学习",
    "related_courses": "相关课程",
    "resources": "资源",
    "saved_to_my_courses": "已保存到书签",
    "schedule": "课程表",
    "show_more": "显示更多",
    "signing_certificate": "签署证书",
    "smartcase": "SMARTCASE",
    "start": "开始",
    "start_course": "开始课程",
    "start_exam": "开始测验",
    "tap_to_download": "点按以下载",
    "tap_to_remove": "点按以删除",
    "test": "测试",
    "the_exam_time_will_begin": "当你开始第一节课时，测验计时器就会开始计时。在{timeLimitHours}小时之后，你的测验将结束，不可再进行作答。",
    "time_limit": "时间限制",
    "title_not_available": "标题不可用",
    "verified_identity_thanks": "感谢您验证您的身份。现在开始你的考试。",
    "verify_identity": "验证身份",
    "view_schedule": "查看课程表",
    "we_suggest_following_x": "我们建议您先熟悉以下课程中的材料，然后才开始 <strong>{title}</strong>：",
    "you_have_x_remaining": "你还剩余<timeLeft>{timeLeft}</timeLeft>",
    "you_will_have_x_hours": "自测验开始起，你可在{numHours}小时内完成该测验。",
    "course_information": "课程信息",           
    "server_error": "服务器错误",           
    "retry": "重试",           
    "beta_message": "测试版课程仍在开发中！它们供大胆的学习者尝试课业的早期版本。"           
}
};